import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgUserCircle = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M14 2.625A11.375 11.375 0 1 0 25.375 14 11.387 11.387 0 0 0 14 2.625ZM8.103 21.602a7 7 0 0 1 11.795 0 9.606 9.606 0 0 1-11.795 0Zm2.397-8.477a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0Zm10.692 7.264a8.713 8.713 0 0 0-3.944-3.145 5.25 5.25 0 1 0-6.496 0 8.712 8.712 0 0 0-3.944 3.145 9.625 9.625 0 1 1 14.384 0Z" />
  </svg>
);
export default SvgUserCircle;
